export const sexeData = [
    {
        code: 'MASCULIN',
        label: 'Masculin'
    },
    {
        code: "FEMININ",
        label: "Féminin"
    },
]